<script lang="tsx">
import { defineComponent, watch, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Select } from 'ant-design-vue'
import { useFetch } from '@/hooks/useFetch'
import { API_JT_PROJ_HOUSE_LIST } from '@/api/jtProj'
import { getHouseText, HouseDisplay } from './CommonDisplay'
const [name] = createNamespace('JtZchHouseSelect')
export default defineComponent({
  name,
  props: {
    projectId: {
      type: String as PropType<string>,
      required: true
    }
  },
  setup(props, { attrs }) {
    const { loading, result, fetchData } = useFetch({
      getFn: API_JT_PROJ_HOUSE_LIST,
      isShallow: true
    })
    watch(
      () => props.projectId,
      nval => {
        if (nval) fetchData(nval)
      },
      { immediate: true }
    )
    return () => (
      <Select
        loading={loading.value}
        style='width: 100%'
        optionLabelProp='label'
        showSearch
        optionFilterProp='label'
        allowClear
        placeholder='请选择'
        {...attrs}
      >
        {result.value?.map(item => (
          <Select.Option key={item.id} label={getHouseText(item, true)}>
            <HouseDisplay house={item} withCommunity />
          </Select.Option>
        ))}
      </Select>
    )
  }
})
</script>
